module.exports = __webpack_public_path__ + "img/sm-twitter-o.0188eabf.svg";